import React, { useEffect } from 'react';
import _ from 'underscore';
import { useExtendState } from 'helpers/use_extend_state';
import DateInput from '../../../components/date_input';
import Select from '../../../components/select';
import classNames from 'classnames';
import Input from '../../../components/input';
import FeatureNames from 'constants/feature_names';

const statusOptions = [
  { value: 'started', label: 'Enrolled' },
  { value: 'completed', label: 'Completed' },
  { value: 'stopped_due_to_inactivity', label: 'Stopped (inactive)' },
  { value: 'stopped', label: 'Unenrolled' },
  { value: 'paused', label: 'Paused' },
  { value: 'error', label: 'Error' },
];

interface EnrolledSequencesReportFiltersProps {
  initialFilters: any;
  onChange: (filters: any) => void;
  humanizedTypes: any[];
  triggers: any[];
  categories: any[];
  inModal?: boolean;
}

const EnrolledSequencesReportFilters = ({
  inModal,
  initialFilters,
  onChange,
  humanizedTypes,
  triggers,
  categories,
}: EnrolledSequencesReportFiltersProps) => {
  const [filters, extendFilters] = useExtendState<any>(initialFilters);

  useEffect(() => {
    if (!_.isEqual(initialFilters, filters)) {
      extendFilters(initialFilters);
    }
  }, [initialFilters]);

  useEffect(() => {
    onChange(filters);
  }, [filters]);

  return (
    <div
      className={classNames({
        'table-header-filters': !inModal,
        'table-header-filters--modal': inModal,
      })}
    >
      <div className="table-header-filters__item">
        <label>{FeatureNames.SEQUENCE} name</label>
        <Input
          onChange={(sequence_name) => extendFilters({ sequence_name })}
          value={filters.sequence_name}
          size="sm"
        />
      </div>

      <div className="table-header-filters__item">
        <label>Type</label>
        <Select
          options={triggers}
          getLabel={(item) => humanizedTypes[item]}
          onChange={(trigger) => extendFilters({ trigger })}
          value={filters.trigger}
          emptyLabel="All types"
          allowEmptyOption
          variant="v2"
          size="sm"
        />
      </div>

      {categories.length > 0 && (
        <div className="table-header-filters__item">
          <label>Category</label>
          <Select
            options={categories}
            getValue={(item) => item.id}
            getLabel={(item) => item.name}
            onChange={(sequence_category_id) => extendFilters({ sequence_category_id })}
            value={filters.sequence_category_id}
            emptyLabel="All categories"
            allowEmptyOption
            variant="v2"
            size="sm"
          />
        </div>
      )}

      <div className="table-header-filters__item">
        <label>Status</label>
        <Select
          options={statusOptions}
          onChange={(sequence_status) => extendFilters({ sequence_status })}
          value={filters.sequence_status}
          emptyLabel="All statuses"
          allowEmptyOption
          variant="v2"
          size="sm"
        />
      </div>

      <div className="table-header-filters__item">
        <label>Last activity after</label>
        <DateInput
          value={filters.last_activity_from}
          onChange={(last_activity_from) => extendFilters({ last_activity_from })}
          variant="36"
          appendToBody={!inModal}
          fullWidth={inModal}
        />
      </div>
      <div className="table-header-filters__item">
        <label>Last activity before</label>
        <DateInput
          value={filters.last_activity_to}
          onChange={(last_activity_to) => extendFilters({ last_activity_to })}
          variant="36"
          appendToBody={!inModal}
          fullWidth={inModal}
        />
      </div>
    </div>
  );
};

export default EnrolledSequencesReportFilters;
